<template>
  <div
    class="select-input"
    :class="async && options.length == 0 ? 'select-hide-options' : ''"
  >
    <v-select
      class="single-select"
      v-model="computedValue"
      :options="optionsFiltered"
      label="text"
      :clearable="clearable"
      :disabled="disabled"
      :filterable="!async"
      :placeholder="placeholder"
      @search="search"
      @option:selected="$emit('change', $event)"
    >
      <template v-if="async" #no-options="{ search }">
        {{ search && search.length > 3 ? "Sorry, no matching options" : "" }}
      </template>
      <template v-if="async" #open-indicator>
        <span></span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  compatConfig: {
    MODE: 3
  },
  emits: ["update:model-value", "change"],
  props: {
    modelValue: { type: [String, Number, Object, Array] },
    options: { type: Array, default: () => [] },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    async: { type: Boolean, default: false },
    placeholder: { type: String, default: "Select an option" }
  },
  data() {
    return {
      onceSelectedOptions: [],
      lastTimeout: null
    };
  },
  methods: {
    search(search, loading) {
      if (this.async) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          if (search.trim().length >= 3) {
            loading(true);
            this.$emit("search", { query: search, loading });
          }
        }, 1000);
      }
    }
  },
  computed: {
    computedValue: {
      get() {
        var selectedOption = [
          ...this.options,
          ...this.onceSelectedOptions
        ].find((option) => option.value == this.modelValue);
        return selectedOption ? selectedOption : null;
      },
      set(newValue) {
        if (newValue) {
          this.onceSelectedOptions.push(newValue);
        }
        this.$emit("update:modelValue", newValue ? newValue.value : null);
      }
    },
    optionsFiltered() {
      return this.options.filter((option) => !option.excludeFromList);
    }
  }
};
</script>

<!-- <style>
@import "vue-select/dist/vue-select.css";
</style> -->
<style scoped lang="scss">
// @import "@/assets/css/_variables.scss";

// .select-input {
//   width: 100%;
//   min-width: 3.5rem;

//   :deep(> *) {
//     --vs-font-size: 0.875rem;
//     --vs-line-height: 1.5;
//     --vs-actions-padding: 2px 0 0 3px;
//     --vs-border-color: transparent;
//     --vs-border-width: 0;
//     --vs-dropdown-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.36);
//     --vs-dropdown-option-padding: 10px 27px;
//     --vs-dropdown-max-height: 20rem;
//     --vs-selected-color: $font-color;
//   }
// }
// .single-select {
//   box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.16);
//   border-radius: var(--border-radius-md);
// }

// .single-select :deep(.vs__dropdown-menu) {
//   border-radius: var(--border-radius-lg);
//   padding-top: 0;
//   padding-bottom: 0;
//   margin-top: 0.1875rem;

//   .vs__dropdown-option--highlight:not(.vs__dropdown-option--selected) {
//     background-color: white;
//     color: unset;
//   }
//   .vs__dropdown-option--highlight:hover {
//     background-color: rgba($light-blue, 0.11);
//   }

//   .vs__dropdown-option--selected {
//     background-color: rgba($light-blue, 0.11);
//     color: var(--primary);
//   }

//   .vs__dropdown-option {
//     width: fit-content;
//     min-width: 100%;
//   }
// }
// :deep(.vs--searchable:not(.vs--open)) {
//   .vs__dropdown-toggle {
//     cursor: pointer;

//     .vs__search {
//       cursor: pointer;
//     }
//   }
// }
// :deep(.vs__selected-options) {
//   max-width: calc(100% - 1.25rem);
// }
// :deep(.vs__selected) {
//   margin: 0;
//   height: 100%;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   overflow: hidden;
//   min-width: 1.25rem;
//   max-width: 100%;
// }
// :deep(.vs__search) {
//   margin-top: 1px;
//   min-width: 3.125rem;
// }
// :deep(.vs__dropdown-toggle) {
//   padding: 0 0.5rem 0.125rem;
//   height: 1.875rem;
// }
// :deep(.vs__clear) {
//   margin-top: -4px;
// }
// .select-hide-options :deep(.vs__dropdown-menu) {
//   display: none;
// }
// .select-hide-options :deep(.vs--open .vs__dropdown-toggle) {
//   border-bottom-color: var(--primary) !important;
//   border-bottom-width: 1px;
//   border-radius: var(--border-radius-md);
// }
</style>
